import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface ReportHubQuerysInProgressState {
  value: boolean;
}

const initialState: ReportHubQuerysInProgressState = { value: false };

export const reportHubQuerysInProgressSlice = createSlice({
  name: 'reportHubQuerysInProgress',
  initialState,
  reducers: {
    setReportHubQuerysInProgress: (state: ReportHubQuerysInProgressState, action: PayloadAction<boolean>) => {
      state.value = action.payload;
    },
  },
});

export const selectedReportHubQuerysInProgress = (state: RootState) => state.reportHubQuerysInProgress.value;

export const { setReportHubQuerysInProgress } = reportHubQuerysInProgressSlice.actions;

export default reportHubQuerysInProgressSlice.reducer;
